import React from 'react'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import { PropTypes } from 'prop-types'
import Tab from '@mui/material/Tab'
import { modalTiers } from '../../config/generalInputs.config'
import config from '../../config/config'
import { SectionTitle } from '../ProjectInputs/ProjectInputs'
import { BICYCLE } from '../../constants/modalTiers'
import ModalCriteria from './ModalCriteria'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

export default function CriteriaAccordion() {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <SectionTitle>Build Your Project</SectionTitle>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          padding: '0.5em',
          pt: '1em'
        }}
        className="travellertype-accordion"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic modal tier tabs"
          variant="fullWidth"
          TabIndicatorProps={{
            style: {
              backgroundColor: config.themeConfig.semcogGreen,

              borderRadius: '50px',
              height: '100%'
            }
          }}
        >
          {modalTiers.map((tier, index) => (
            <Tab
              sx={
                value === index
                  ? {
                      fontWeight: 600,
                      fontSize: `${config.themeConfig.textFontSize}px`,

                      color: 'white',
                      '&.Mui-selected': {
                        color: '#fff',
                        zIndex: 1000
                      }
                    }
                  : {
                      fontSize: `${config.themeConfig.textFontSize}px`
                    }
              }
              label={tier.name === BICYCLE ? 'Bike' : tier.name}
              key={`${tier.name}-tab`}
              {...a11yProps(index)}
              className={`${tier.name}-accordion-tab`}
            />
          ))}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ModalCriteria
          modalConfig="pedestrianConfig"
          travellerType="pedestrian"
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ModalCriteria modalConfig="bicycleConfig" travellerType="bicycle" />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ModalCriteria modalConfig="transitConfig" travellerType="transit" />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ModalCriteria modalConfig="autoConfig" travellerType="auto" />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <ModalCriteria modalConfig="freightConfig" travellerType="freight" />
      </TabPanel>
    </Box>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
}
